<div class="websocket-tab">
  <ix-message-list></ix-message-list>
</div>
